import { createSelector } from '@reduxjs/toolkit';
import memoize from 'lodash/memoize';
import type { CommonState } from 'c-types';

export const getPermissionsDictionary = (state: CommonState) => state.role.roleEditingPermissions;

export const getPermissionStateById = createSelector(getPermissionsDictionary, perms =>
    memoize((id: number) => perms[id] ?? false),
);
